export const REGISTER_ACTION_MENU_KEY = "register";
export const REGISTRATION_GROUP_MENU_KEY = "registration";
export const INSTITUTE_STATS_DASHBOARD_MENU_KEY = "instituteStatsDashboard";
export const ACADEMIC_CALENDAR_MENU_KEY = "academicCalendar";
export const DASHBOARD_MENU_KEY = "dashboard";
export const APPLICATIONS_MENU_KEY = "applications";
export const ADMISSIONS_LIST_MENU_KEY = "admissionsList";
export const APPLICATIONS_REVIEW_MENU_KEY = "applicationsReview";
export const TRACK_APPLICATION_MENU_KEY = "trackApplication";
export const E_CHALLAN_STATUS_MENU_KEY = "eChallanStatus";
export const E_CHALLAN_SUMMARY_MENU_KEY = "eChallanSummary";
export const CERTIFICATE_MENU_KEY = "certificate";
export const COURSES_MENU_KEY = "courses";
export const OPEN_ADMISSION_MENU_KEY = "openAdmission";
export const MANAGE_SESSIONS_MENU_KEY = "manageSessions";
export const FACULTY_MENU_KEY = "faculty";
export const ATTENDANCE_MENU_KEY = "attendance";
export const STUDENT_ATTENDANCE_MENU_KEY = "studentAttendance";
export const FACULTY_ATTENDANCE_MENU_KEY = "facultyAttendance";
export const PROMOTION_MENU_KEY = "promotion";
export const DROPOUT_MENU_KEY = "dropout";
export const MIGRATION_REQUESTS_MENU_KEY = "migrationRequests";
export const EMPLOYMENT_STATUS_MENU_KEY = "employmentStatus";
export const MANAGE_OJT_MENU_KEY = "manageOjt";
export const RESULT_MANAGEMENT_MENU_KEY = "resultManagement";
export const SESSION_STUDENTS_MENU_KEY = "sessionStudents";
export const STUDENT_CERTIFICATES_MENU_KEY = "studentCertificates";


export type SidebarMenuKey =
	| typeof REGISTER_ACTION_MENU_KEY
	| typeof REGISTRATION_GROUP_MENU_KEY
	| typeof INSTITUTE_STATS_DASHBOARD_MENU_KEY
	| typeof ACADEMIC_CALENDAR_MENU_KEY
	| typeof DASHBOARD_MENU_KEY
	| typeof APPLICATIONS_MENU_KEY
	| typeof ADMISSIONS_LIST_MENU_KEY
	| typeof APPLICATIONS_REVIEW_MENU_KEY
	| typeof TRACK_APPLICATION_MENU_KEY
	| typeof E_CHALLAN_STATUS_MENU_KEY
	| typeof E_CHALLAN_SUMMARY_MENU_KEY
	| typeof CERTIFICATE_MENU_KEY
	| typeof COURSES_MENU_KEY
	| typeof OPEN_ADMISSION_MENU_KEY
	| typeof MANAGE_SESSIONS_MENU_KEY
	| typeof FACULTY_MENU_KEY
	| typeof ATTENDANCE_MENU_KEY
	| typeof STUDENT_ATTENDANCE_MENU_KEY
	| typeof FACULTY_ATTENDANCE_MENU_KEY
	| typeof PROMOTION_MENU_KEY
	| typeof DROPOUT_MENU_KEY
	| typeof MIGRATION_REQUESTS_MENU_KEY
	| typeof EMPLOYMENT_STATUS_MENU_KEY
	| typeof MANAGE_OJT_MENU_KEY
	| typeof RESULT_MANAGEMENT_MENU_KEY
	| typeof SESSION_STUDENTS_MENU_KEY
	| typeof STUDENT_CERTIFICATES_MENU_KEY;
